import React, {Component} from 'react';
import {Button, Card, Col, Form, Input, message, Modal, Row, Select, Table} from 'antd';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';

import moment from 'moment';
import util from '@util/index';
import sessionDb from '@util/sessionDb';
import {queryIncCustomList, queryIncCustomProject} from '@api/incubator/custom';
import {
  queryDeleteIncuOregistapp,
  queryIncuOregistappIsApply,
  querySaveIncuOregistapp,
} from '@api/incubator/oregistapp';

import {BackBtn} from '@comm/BackBtn';
import FlowOp from '@comm/workflow/submitOp';
import TableFile from '../../comm/TableFile';
import ModalFileList from '../../comm/ModalFileList';
import ComAddressSelect from '../comm/ComAddressSelect';
import ModalSettledList from '../comm/ModalSettledList';

const FormItem = Form.Item;
const {Option} = Select;

class PageAddress extends Component {
  constructor(props) {
    super(props);
    const data = sessionDb.get('pageAddressData') || props.data;
    this.state = {
      data,
      isApply: false,
      visible: false,
      fileVisible: false,

      customList: [],
      projectList: [],
      fileList: data ? data.files || data.fileList || [] : [],
      addresses: data ? data.addresses || [] : [],
      settled: data && data.currentSettled ? data.currentSettled : {},
      addressUuids: data && data.addresses ? data.addresses.map(item => item.uuid) : [],
    };
  }

  componentWillMount() {
  }

  componentDidMount() {
    const {data} = this.state;
    this.getIncCustomList();
    if (data && data.customUuid) {
      this.customUuid = data.customUuid;
      this.setState({
        customUuid: data.customUuid,
      });
      this.getIncCustomProject();
    }
  }

  componentWillUnmount() {
    if (this.saveFlag) {
      sessionDb.set('pageAddressData', this.getPageAddressData());
    } else {
      sessionDb.set('pageAddressData', null);
    }
  }

  getPageAddressData = () => {
    const {data, addresses, settled, addressUuids} = this.state;
    const values = this.props.form.getFieldsValue();
    if (data) {
      values.uuid = data.uuid;
    }
    return {
      ...values,
      addresses,
      addressUuids,
      settledUuid: settled.uuid,
      addressNum: addressUuids.length,
    };
  };

  submit = op => e => {
    if (e) {
      e.preventDefault();
    }
    const {addressUuids, fileList, settled, isApply} = this.state;
    const {data} = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (isApply) {
          message.warn('该公司已有注册地址，不能再申请!');
          return;
        }
        if (!addressUuids.length) {
          message.warn('没有选择地址！');
          return;
        }
        if (!fileList.length) {
          message.warn('没有上传附件！');
          this.setState({
            showFileTips: true,
          });
          return;
        }
        if (!this.validateSettled()) {
          return;
        }
        values.settledUuid = settled.uuid;

        if (data) {
          values.uuid = data.uuid;
        }
        const params = {
          ...values,
          addressUuids,
          addressNum: addressUuids.length,
          files: fileList,
        };
        if (op === 'audit') {
          this.saveIncuOregistapp(params);
        } else {
          message.warn('保存草稿功能正在开发，敬请期待！');
        }
      }
    });
  };

  getIncCustomList = (condition = '') => {
    queryIncCustomList({condition}).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          customList: res.data,
        });
      }
    });
  };

  getIncCustomProject = () => {
    queryIncCustomProject({
      customUuid: this.customUuid,
    })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            projectList: res.data,
          });
        }
      });
  };

  getIncuOregistappIsApply = () => {
    const incubatorUuid = this.props.params.uuid;
    queryIncuOregistappIsApply({
      incubatorUuid,
      customUuid: this.customUuid,
    })
      .then(res => {
        if (res.statusCode === 200) {
          this.setState({
            isApply: res.data.isApply,
          });
        }
      });
  };

  saveIncuOregistapp = params => {
    this.setState({
      submiting: true,
    });
    querySaveIncuOregistapp(params).then(res => {
      this.setState({
        submiting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/oregistapp_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleCustomChange = (e, option) => {
    this.props.form.setFieldsValue({custom: option.props.children});
    this.customUuid = e;
    this.setState({
      customUuid: this.customUuid,
    });
    this.getIncuOregistappIsApply();
    this.getIncCustomProject();
  };

  handleSearch = value => {
    this.getIncCustomList(value);
  };

  handleProjectChange = (e, option) => {
    this.props.form.setFieldsValue({projectName: option.props.children});
  };

  handleChooseSettled = settled => {
    if (settled && settled.uuid) {
      this.setState({
        showSettledTips: false,
      });
    }
    this.setState({
      settled,
    });
  };

  validateSettled = () => {
    const {settled} = this.state;
    if (!(settled && settled.uuid)) {
      message.warn('没有选择关联的基础孵化合同！');
      this.setState({
        showSettledTips: true,
      });
      return false;
    }
    return true;
  };

  handleDelete = uuid => {
    queryDeleteIncuOregistapp({uuid}).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/oregistapp_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleAddressChange = (addressUuids, addresses) => {
    this.setState({
      addressUuids,
      addresses,
    });
  };

  handleSetAddress = () => {
    this.handleVisible(false);
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleSettledVisible = flag => {
    this.setState({
      settledVisible: !!flag,
    });
  };

  getIncubatorName = incubatorUuid => {
    const {incubatorList} = this.props;
    const currentIncu = incubatorList.find(item => item.uuid === incubatorUuid);
    return currentIncu ? currentIncu.name : '';
  };

  changeSettledPage = settledUuid => {
    this.saveFlag = true;
    browserHistory.push(`/incubator/contract/${settledUuid}/info`);
  };

  // ----------------------------------------关于文件------------------------------------------------
  // 文件选择模态框
  handleFileVisible = flag => {
    this.setState({
      fileVisible: !!flag,
    });
  };

  // 确认选择文件
  handleChooseFile = params => {
    this.setState({
      fileList: params,
      showFileTips: params.length === 0,
    });
  };

  columns = () => {
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        render: (text, record) => (
          <a onClick={() => this.changeSettledPage(record.businessUuid)}>{record.no}</a>
        ),
      },
      {
        title: '合同周期',
        dataIndex: 'beginDate',
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '交易类型',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          return (
            <span>{record.price === 0 && record.indeposit === 0 ? '免费注册' : '收费注册'}</span>
          );
        },
      },
      {
        title: '合同金额',
        dataIndex: 'price',
        key: 'price',
        render: (text, record) => {
          return <span>{text ? util.numberFormat(text) : ''}</span>;
        },
      },
      {
        title: '推荐人员',
        dataIndex: 'recommend',
        key: 'recommend',
        render: (text, record) => {
          return (
            <span>
              {text}
              <span style={{marginLeft: '10px'}}>{record.recommendTel}</span>
            </span>
          );
        },
      },
    ];
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {
      isApply,
      visible,
      submiting,
      projectList,

      fileList,
      fileVisible,
      showFileTips,

      customList,
      customUuid,

      addresses,
      addressUuids,

      settled,
      settledVisible,
      showSettledTips,
    } = this.state;
    const {data} = this.state;

    const ItemLayout = {
      labelCol: {span: 6},
      wrapperCol: {span: 16},
    };

    const ItemLayout2 = {
      labelCol: {span: 3},
      wrapperCol: {span: 20},
    };
    getFieldDecorator('custom', {initialValue: data ? data.custom : ''});
    getFieldDecorator('projectName', {
      initialValue: data ? data.projectName : '',
    });
    const incubatorName = this.getIncubatorName(data ? data.incubatorUuid : this.props.params.uuid);
    getFieldDecorator('incubator', {initialValue: incubatorName});
    getFieldDecorator('incubatorUuid', {
      initialValue: data ? data.incubatorUuid : this.props.params.uuid,
    });
    return (
      <Form>
        <div style={{marginBottom: 15}}>
          <BackBtn/>
          <FlowOp handleClick={this.submit} loading={submiting}/>
          {data && data.uuid ? (
            <Button
              icon="delete"
              style={{marginRight: 10}}
              onClick={() => this.handleDelete(data.uuid)}
            >
              删除
            </Button>
          ) : null}
        </div>
        <Card title="注册主体" className="mb16">
          <Row>
            <Col span={10} style={{position: 'relative'}}>
              <FormItem label="公司名称" {...ItemLayout}>
                {getFieldDecorator('customUuid', {
                  rules: [{required: true, message: '请输入公司名称!'}],
                  initialValue: data ? data.customUuid : '',
                })(
                  <Select
                    onChange={this.handleCustomChange}
                    showSearch
                    filterOption={false}
                    onSearch={this.handleSearch}
                  >
                    {data && data.customUuid ? (
                      <Option key={data.customUuid}>{data.custom}</Option>
                    ) : null}
                    {customList.map(item => (
                      <Option key={item.customUuid}>{item.customName}</Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
              <span
                style={{
                  position: 'absolute',
                  top: '35px',
                  left: '25%',
                }}
              >
                {isApply ? (
                  <span style={{color: 'red'}}>该公司已有注册地址，不能再申请！</span>
                ) : null}
              </span>
            </Col>
            <Col span={10}>
              <FormItem label="项目名称" {...ItemLayout}>
                {getFieldDecorator('projectId', {
                  initialValue: data ? data.projectId : '',
                })(
                  <Select onChange={this.handleProjectChange}>
                    {projectList.map(item => (
                      <Option key={item.id}>{item.projectName}</Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="孵化器" {...ItemLayout}>
                {incubatorName}
              </FormItem>
            </Col>
          </Row>
        </Card>
        <Card title="地址信息" className="mb16">
          <Row>
            <Col span={20}>
              <FormItem
                label={
                  <span>
                    <span style={{color: 'red'}}>* </span>关联基础孵化合同
                  </span>
                }
                {...ItemLayout2}
                style={{marginBottom: '0'}}
              >
                {customUuid ? (
                  <a onClick={() => this.handleSettledVisible(true)}>选择合同</a>
                ) : null}
                {showSettledTips ? (
                  <span style={{color: 'red', paddingLeft: '10px'}}>选择对应基础孵化合同！</span>
                ) : null}
              </FormItem>
            </Col>
            <Col span={22} style={{paddingLeft: '25px'}}>
              {settled && settled.uuid ? (
                <Table
                  columns={this.columns()}
                  dataSource={[settled]}
                  pagination={false}
                  rowKey="uuid"
                />
              ) : null}
            </Col>
            <Col span={20}>
              <FormItem
                label={
                  <span>
                    <span style={{color: 'red'}}>*</span>使用地址
                  </span>
                }
                {...ItemLayout2}
                style={{marginTop: '20px'}}
              >
                <span>{addressUuids.length}个</span>
                <Button onClick={() => this.handleVisible(true)} style={{marginLeft: '8px'}}>
                  编辑
                </Button>
                <div>
                  {addresses.map(item => {
                    return (
                      <p
                        style={{
                          marginBottom: '2px',
                          height: '20px',
                          lineHeight: '20px',
                        }}
                        key={item.uuid}
                      >
                        {item.name}
                      </p>
                    );
                  })}
                </div>
              </FormItem>
            </Col>
          </Row>
        </Card>
        <Card title="相关文件" className="mb16">
          <Row>
            <Col span={20}>
              <FormItem label="相关附件" {...ItemLayout2}>
                {customUuid ? <a onClick={() => this.handleFileVisible(true)}>选择附件</a> : null}
                {showFileTips ? (
                  <span style={{color: 'red', paddingLeft: '10px'}}>附件必须上传！</span>
                ) : null}
                {fileList.length > 0 ? (
                  <TableFile dataSource={fileList} handleChooseFile={this.handleChooseFile}/>
                ) : null}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="申请备注" {...ItemLayout2}>
                {getFieldDecorator('reason', {
                  rules: [{required: true, message: '请输入申请备注'}],
                  initialValue: data ? data.reason : '',
                })(
                  <Input.TextArea
                    placeholder="申请备注"
                    type="textarea"
                    autosize={{minRows: 3, maxRows: 9}}
                    maxLength={1000}
                  />,
                )}
                <span style={{fontSize: '12px', color: '#999'}}>*最多可输入1000字</span>
              </FormItem>
            </Col>
          </Row>
        </Card>
        <Modal
          visible={visible}
          width={900}
          title="选择地址"
          onCancel={() => this.handleVisible(false)}
          onOk={this.handleSetAddress}
        >
          <ComAddressSelect
            incubatorUuid={data ? data.incubatorUuid : this.props.params.uuid}
            handleChange={this.handleAddressChange}
            addresses={addresses}
          />
        </Modal>
        {fileVisible ? (
          <ModalFileList
            customUuid={customUuid}
            fileVisible={fileVisible}
            selectedRows={fileList}
            handleCancel={this.handleFileVisible}
            handleChooseFile={this.handleChooseFile}
          />
        ) : null}
        {settledVisible ? (
          <ModalSettledList
            customUuid={customUuid}
            incubatorUuid={data ? data.incubatorUuid : this.props.params.uuid}
            selectedRowKeys={[settled.uuid]}
            visible={settledVisible}
            changePage={this.changeSettledPage}
            handleCancel={this.handleSettledVisible}
            onOk={this.handleChooseSettled}
          />
        ) : null}
      </Form>
    );
  }
}

export default connect(state => ({
  incubatorList: state.incubator_list,
}))(Form.create({wrappedComponentRef: true})(PageAddress));



// WEBPACK FOOTER //
// ./src/components/incubator/contract/address/PageAddress.js